import { useSearchParams } from 'next/navigation';

import { useIsWebview } from '../hooks/useIsWebview';

export const useWebviewThemeParameter = (): {
  theme: 'light' | 'dark' | undefined;
  isDarkTheme: boolean;
} => {
  const isWebview = useIsWebview();
  const searchParams = useSearchParams();

  const themeParameter = searchParams.get('theme');

  if (!themeParameter) {
    return {
      theme: isWebview ? 'light' : undefined,
      isDarkTheme: false,
    };
  }

  const theme = themeParameter === 'dark' ? 'dark' : 'light';

  return {
    theme,
    isDarkTheme: theme === 'dark',
  };
};
